import React, {useRef} from 'react'

import Style from './style'

import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import usePutManagerPassowrd from 'entity/auth/usePutManagerPassowrd'
import usePutSubManagerPassowrd from 'entity/auth/usePutSubManagerPassowrd'
import useRoleCookie from 'shared/model/useRoleCookie'
import {
	ROLE_COMPETITION_MANAGER,
	ROLE_FIELD_MANAGER,
	ROLE_TIMER_MANAGER,
} from 'shared/constant/lookup/role'
import {pwRegx} from 'shared/lib/inputValidation'
import usePutProfilePassword from 'entity/auth/usePutProfilePassword'

const ChangePasswordModal = ({closeEvent, managerId}) => {
	const newPwRef = useRef()
	const confirmPwRef = useRef()

	// Mock ref for manager ID to match hook expectation
	const idRef = useRef({value: managerId})

	const [requestChange] = usePutManagerPassowrd(idRef, newPwRef)
	const [requestSubManagerChange] = usePutSubManagerPassowrd(
		idRef,
		newPwRef,
		true
	)
	const [requestProfileChange] = usePutProfilePassword(idRef, newPwRef)
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()

	const handleChange = () => {
		const newPw = newPwRef.current.value
		const confirmPw = confirmPwRef.current.value

		if (!newPw || !confirmPw) {
			setAlert('비밀번호를 입력해주세요.')
			return
		}

		if (newPw !== confirmPw) {
			setAlert('비밀번호가 일치하지 않습니다.')
			return
		}

		if (!pwRegx.test(newPw)) {
			setAlert('비밀번호는 영문, 숫자, 특수문자를 포함하여 6~20자여야 합니다.')
			return
		}

		if (userRole === ROLE_COMPETITION_MANAGER) {
			requestSubManagerChange()
		} else if (
			userRole === ROLE_FIELD_MANAGER ||
			userRole === ROLE_TIMER_MANAGER
		) {
			requestProfileChange()
		} else {
			requestChange()
		}
	}

	return (
		<DefaultModal title='비밀번호 변경' closeEvent={closeEvent}>
			<Style.ContentDiv>
				<Style.FormDiv>
					<input ref={newPwRef} type='password' placeholder='새 비밀번호' />
					<input
						ref={confirmPwRef}
						type='password'
						placeholder='새 비밀번호 확인'
					/>
				</Style.FormDiv>
				<Style.BtnDiv>
					<DefaultButton clickEvent={handleChange}>변경</DefaultButton>
				</Style.BtnDiv>
			</Style.ContentDiv>
		</DefaultModal>
	)
}

export default ChangePasswordModal
